
import { computed, defineComponent, PropType, toRef } from 'vue';
import { Truck } from '@/types/app';
import AppTable from '@/components/tables/base/AppTable.vue';
import Timestamp from '@/components/tables/TimestampCell.vue';
import { useTableSorting } from '@/utils';
import MaterialIcon from '@/components/MaterialIcon.vue';
import CheckboxInput from '../form-controls/base/CheckboxInput.vue';

export default defineComponent({
  name: 'TrucksTable',
  components: {
    AppTable,
    Timestamp,
    MaterialIcon,
    CheckboxInput
  },
  props: {
    trucks: {
      type: Array as PropType<Array<Truck>>,
      required: true
    }
  },
  emits: ['update:truck'],
  setup(props, { emit }) {
    const trucksRef = toRef(props, 'trucks');

    const normalizedTrucks = computed(() => {
      return trucksRef.value.map(truck => ({
        ...truck,
        enabled: truck.enabled !== undefined && truck.enabled !== null ? truck.enabled : true,
        weight: truck.weight !== null && truck.weight !== undefined ? truck.weight : 0,
        lastUpdatedOn: truck.lastUpdatedOn || { timestamp: { seconds: 0, nanoseconds: 0 }, user: null }
      }));
    });

    const { sortedData: sortedTrucks, sortBy, getSortState } = useTableSorting(normalizedTrucks, 'name');

    const updateTruck = (truck: Truck) => {
      emit('update:truck', truck);
    };

    return {
      sortedTrucks,
      sortBy,
      getSortState,
      updateTruck
    };
  }
});
